import { forwardRef, type Ref, type SVGProps } from "react";
const IconUserAddFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a7 7 0 0 0-7 7.07v1.43a9 9 0 0 0 3 6.5c-5.78.86-10 3.83-10 7v4a2 2 0 0 0 2 2h15a.5.5 0 0 0 .39-.81 7 7 0 0 1 2.87-10.64.5.5 0 0 0 0-.92A11.7 11.7 0 0 0 20 17a9.08 9.08 0 0 0 3-6.5V9.07A7 7 0 0 0 16 2" />
    <path d="M29 24h-3v-3a1 1 0 0 0-2 0v3h-3a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconUserAddFilledSVG);
ForwardRef.displayName = "IconUserAddFilled";
export { ForwardRef as IconUserAddFilled };
